var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.haveToDoTest)?_c('v-badge',{attrs:{"color":"error","dot":""}},[_c('span',[_vm._v("Mes défis")])]):_c('span',[_vm._v("Mes défis")])}
var staticRenderFns = []

export { render, staticRenderFns }